import React from "react";

const Sampleurl = () => {
    return (
        <div className="chartbotinsideopen" >
            <div className='containers' id='ChatBotContainer'>
                <div className='headAndOutput'>

                    <div className="d-block d-md-none">
                        <div className="chatHead  justify-content-start align-items-start" style={{ padding: "0px 10px" }}>
                            <div className="headIcontext">
                                <div className="group-2"></div>
                                <div className="iconHeadChat">
                                    <div className="imageHolderchat inmobileVideoPlay"   >

                                    </div>

                                </div>
                            </div>
                            <div className="headMinClose headTextClass d-grid ps-3 mt-4">
                                <p className="miniHead"  >Chat With</p>
                                <p className='font-sizemim'> </p>

                            </div>
                            <div className='closeiconsandexpnd'>
                                <div style={{ position: "relative" }}>
                                    <div className="custom-select">
                                        <label htmlFor="languagesselect"  >
                                            <label htmlFor='languagesselect' >
                                                EN
                                            </label>
                                        </label>
                                        <select className='languagesselect' id="languagesselect"   >
                                            <option value="" >select</option>
                                        </select>
                                    </div>
                                </div>
                                <span className='iconsbackground2 '  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-volume-x"><path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path><line x1="22" x2="16" y1="9" y2="15"></line><line x1="16" x2="22" y1="9" y2="15"></line></svg>
                                </span>
                                {/* <div className='close-top'  onClick={() => { setexpandChat(!expandChat); }}>
                                        <span className="iconsbackground2"  >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrows-angle-expand" viewBox="0 0 16 16">
                                                <path fillRule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707" />
                                            </svg>
                                        </span>
                                    </div> */}
                                <div className='close-top' style={{ width: "45px" }}  >

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='d-none d-md-block'>
                        <div className='chatHead '>
                            <div className='headIcontext'>
                                <div className='group-2'></div>
                                <div className='iconHeadChat'>
                                    <div className='imageHolderchat' >

                                    </div>

                                    <div className='headTextClass'>
                                        <div className="text-wrapper miniHead">Chat with</div>
                                        <div className="font-sizemim">Avatar</div>
                                    </div>
                                </div>
                            </div>
                            <div className='headMinClose'>
                                <div className='languagesDivBoth'>
                                    <div className='' style={{ position: 'relative' }} >
                                        <div className="custom-select">
                                            <label htmlFor="languagesselect"  >
                                                <label htmlFor='languagesselect' >
                                                    EN
                                                </label>
                                            </label>
                                            <select className='languagesselect' id="languagesselect"   >
                                                <option value="" >select</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className=' speakerIconButton'  >
                                    <span className='iconsbackground'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-volume-x"><path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path><line x1="22" x2="16" y1="9" y2="15"></line><line x1="16" x2="22" y1="9" y2="15"></line></svg>
                                    </span>


                                </div>
                                    

                            </div>
                        </div>
                    </div>
                    <div id="output-container">
                        <div className="messages-container">
                        </div>

                        <div className="hello-container backgroundclass "   >

                        </div>

                    </div>
                </div>

                <div className='outputHelpfulClass'>
                    <form className="input-container">
                        <input type="text" placeholder="Enter your message" />

                        <div className="recording-indicator">
                            <div className='iconButton'>
                                <svg width="46" height="46" fill="none" stroke="black" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="m3 3 18 18"></path>
                                    <path d="M12.87 12.874A3 3 0 0 1 9 10.002v-1"></path>
                                    <path d="M9 5a3 3 0 1 1 6 0v5c0 .296-.044.59-.13.874"></path>
                                    <path d="M17.848 13.85A6.967 6.967 0 0 0 19 10"></path>
                                    <path d="M5 10a7 7 0 0 0 10.846 5.85"></path>
                                    <path d="M8 21h8"></path>
                                    <path d="M12 17v4"></path>
                                </svg>

                            </div>
                        </div>

                        <button type='submit' className='  iconButton2' style={{ background: "none", padding: 0 }}>
                            <span className=' '  >
                                <svg width="25" height="25" fill="none" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 14 21 3"></path>
                                    <path d="m21 3-6.5 18a.55.55 0 0 1-1 0L10 14l-7-3.5a.55.55 0 0 1 0-1L21 3Z"></path>
                                </svg>
                            </span>

                        </button>
                    </form>
                </div>

                <div className='powerdby'>
                    Powered by <span>Avatar Chat Agents</span>
                </div>
            </div>
        </div >


    )
}


export default Sampleurl